import { Component, ElementRef, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DialogComponentContent } from '../../../models/dialogs/DialogComponentContent';
import { FinanceService } from '../../../services/finance.services';

@Component({
    selector: 'anticipated-rescue',
    templateUrl: './anticipated-rescue.component.html',
    styleUrls: ['./anticipated-rescue.component.scss'],
})
export class AnticipatedRescueComponent extends DialogComponentContent {

    public item: any;
    public valueToRescue: any = 0;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<AnticipatedRescueComponent>,
        public element: ElementRef,
        private router: Router,
        private financeService: FinanceService,
    ) {
        super(element);

        this.item = this.data.item;

        if (this.item) {
            this.valueToRescue = this.financeService.calculateAnticipateRedeemValue(
                this.item.anticipateUnitPrice,
                this.item.currentQuantity,
                this.item.pendingRedeemQuantity,
                this.item.scheduleRedeemQuantity,
            );
        } else {
            this.valueToRescue = null;
        }
    }

    public goRoute() {
        this.router.navigate(['/resgate']);
        this.dialogRef.close();
    }

    public dispose() {
        this.dialogRef.close();
    }
}
